// hooks/useError.ts
// Importa o componente de mensagens "message" da biblioteca Ant Design (antd),
// que será utilizado para exibir mensagens de erro na interface.
import { message } from "antd";

// Define o hook customizado `useError` que será utilizado para exibir
// uma mensagem de erro no aplicativo.
export const useError = () => {
  // Usa o hook `message.useMessage` do Ant Design, que retorna duas variáveis:
  // - `messageApi`: a API que permite abrir e controlar as mensagens.
  // - `contextHolder`: um elemento React que deve ser incluído no JSX para
  // permitir que as mensagens apareçam corretamente no layout.
  const [messageApi, contextHolder] = message.useMessage();

  // Função `showError` que exibe uma mensagem de erro com o texto
  // passado como argumento.
  const showError = (texto: string) => {
    messageApi.open({
      type: "error", // Define o tipo da mensagem como "error" (erro).
      content: texto, // Define o conteúdo da mensagem com o texto fornecido.
    });
  };

  // Retorna a função `showError` para ser usada em outros componentes
  // e o `contextHolder` que deve ser renderizado na árvore de componentes.
  return { showError, contextHolder };
};
